import { useEffect, useState } from "react";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { CRSelectorConstants } from "../../../../bpm/config/Componentes/CRSelectorConstants";

interface addCondition {
    TypePerson: any;
    renderLoan: string;
}

interface Props {
    jsonProps: string;
    onChange: Function;
}

export const ListPropsTypePersons = ({ jsonProps, onChange }: Props) => {

    const [format, setFortmat] = useState<Partial<addCondition>>({});
    const [lista, setLista] = useState([]);

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {
        try {
            if (jsonProps && jsonProps.trim() !== "") {
                const parsed = JSON.parse(jsonProps);
                if (Array.isArray(parsed)) {
                    setLista(parsed);
                } else {
                    toast.error("El formato de jsonProps no es una lista válida.");
                    setLista([]);
                }
            } else {
                setLista([]);
            }
        } catch (error) {
            toast.error("Error al parsear jsonProps.");
            setLista([]);
        }
    };

    const addAdditionalProps = (typePerson: any) => {
        if (!typePerson) return typePerson;

        switch (typePerson.Description) {
            case "Pensionado":
                return { ...typePerson, CodigoGrado: "GRADOSPOL" };
            case "Uniformado":
                return { ...typePerson, CodigoGrado: "GRADOSPOL" };
            case "No Uniformado":
                return { ...typePerson, CodigoGrado: "LISTCIVIL" };
            default:
                return { ...typePerson, CodigoGrado: "No Configurado" };
        }
    };


    const create = () => {
        if (!format.TypePerson) {
            toast.error("Debe seleccionar Tipo de Persona");
            return;
        }

        const updatedTypePerson = addAdditionalProps(format.TypePerson);
        setLista([...lista, updatedTypePerson]);

        setFortmat({
            renderLoan: "",
            TypePerson: null,
        });
    };


    const deleteItem = (index: number) => {
        const nuevaLista = lista.filter((_, i) => i !== index);
        setLista(nuevaLista);
    };

    useEffect(() => {
        if (onChange) {
            onChange(JSON.stringify(lista))
        }
    }, [lista])

    return (
        <div className="row">
            <div className="col-md-12 mb-3">
                <div className="row">
                    <div className="col-md-5">
                        <CRSelectorConstants groupDefinition="TIPPERSONAGRADE" idSelector={format.TypePerson?.IDCreditProperties} returnType="Object" label="Tipo de Persona" onChange={(e) => { setFortmat({ ...format, TypePerson: e }) }} />
                    </div>

                    <div className="col-md-2 d-flex align-items-end">
                        <BasicButton eventClick={create} icon="ri-file-add-line">Agregar</BasicButton>
                    </div>
                </div>
            </div>

            <div className="col-md-12">
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Tipo de Persona</th>
                            <th>Codigo de Grados</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lista.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.Description}</td>
                                <td>{item.CodigoGrado}</td>
                                <td>
                                    <BasicButton
                                        eventClick={() => deleteItem(index)}
                                        icon="ri-delete-bin-line"
                                        children="Eliminar"
                                    />
                                </td>
                            </tr>
                        ))}
                        {lista.length === 0 && (
                            <tr>
                                <td colSpan={6} className="text-center">No hay caracterizaciones agregadas</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}